export default "__VITE_ASSET__4e2b46b8__"